// extracted by mini-css-extract-plugin
module.exports = {"mention":"e_yeb"};